<template>
  <div>

    <CRow>
      <CCol md="4">
        <CCard v-if="selected_node!= 0">
          <CCardHeader>
            <strong>{{$t('positionsOf')}} {{ selected_node.name }}</strong>
          </CCardHeader>
          <CCardBody>
            <v-jstree oncontextmenu="return false" v-if="data_accounting_tree.length>0" :data="data_accounting_tree"
                      :klass="tree_view_direction()"
                      show-checkbox
                      allow-batch whole-row></v-jstree>

          </CCardBody>
          <CCardFooter>
            <CButton @click="addGroupModal = true,
        position_or_unit = 1" size="sm" color="primary">
              <CIcon name="cil-plus"/>
            </CButton>

            <CButton @click="addGroupModal = true,
        position_or_unit = 1" size="sm" color="danger">
              <CIcon name="cil-minus"/>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CCol md="8">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="6" style="text-align: start">
                <strong>{{ $t('components.organizationChart') }}</strong>

              </CCol>
              <CCol col="6" style="text-align: end">
                <CSelect
                    :label="$t('components.branch')"
                    :options="branch_items"
                    :value.sync="selected_branch"
                    horizontal
                />
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody style="    text-align: -webkit-center;
">
            <CCol style="direction: ltr" oncontextmenu="return false">
              <TreeChart :json="data_accounting" @click-node="click_node" @right-click-node="right_click_node"/>
            </CCol>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <vue-context ref="menu">
      <li>
        <a href="#" @click.prevent="onClick('addUnit')">{{ $t('components.addUnit') }}</a>

        <a href="#" @click.prevent="onClick('addPosition')">{{ $t('components.addPosition') }}</a>
      </li>
      <li>
        <a href="#" @click.prevent="onClick('edit')">{{ $t('components.edit') }}</a>
      </li>

      <li>
        <a href="#" @click.prevent="onClick('delete')">{{ $t('buttons.delete') }}</a>
      </li>
      <li>
        <a v-if="selected_node.recType==1" href="#"
           @click.prevent="onClick('addUsers')">{{ $t('components.addUser') }}</a>
      </li>
    </vue-context>
    <CModal
        :show.sync="addGroupModal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        :title="$t('components.organizationChart')"
    >

      <CRow>
        <CCol col="6">
          <CInput
              :label="$t('components.name')"
              v-model="name"
          />
        </CCol>
      </CRow>
      <template #footer>
        <CButton v-if="status_form==0" @click="insert_data()"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton v-if="status_form!=0" @click="insert_data()"
                 color="success"
        >{{ $t("buttons.edit") }}
        </CButton>
        <CButton
            @click="addGroupModal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import TreeChart from "vue-tree-chart";
// import '~vue-context/dist/css/vue-context.css';
import 'vue-context/src/sass/vue-context.scss';

import VueContext from 'vue-context';
import VJstree from 'vue-jstree'

export default {
  name: 'Login',
  components: {
    TreeChart,
    VJstree,

    VueContext
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      name: '',
      file: null,
      color: '#ffffff',
      code: '',
      addGroupModal: false,
      details: [],
      collapseDuration: 0,
      data_with_children: [],
      data_accounting_tree: [],
      mouse_position: null,
      data_accounting: {
        id:0,
        name: localStorage.getItem('app_name'),
        image_url: '/img/avatars/custom.png',
        class: ["rootNode"],
        children: []
      },
      status_form: 0,
      position_or_unit: 0,
      selected_node: 0,
      branch_items: [],
      selected_branch: 0,
      itemEvents: {

        contextmenu: function (node) {
          console.log(arguments[2])
          arguments[2].preventDefault()
          // self.on_chart_right_clicked(arguments[2],node)
          // this.$refs.menu.open(arguments[2],null)
          console.log('contextmenu', node.data)
        }
      },
    }
  },
  mounted() {
    var self = this;
    this.$root.root_validate_errors = [];
    document.onmousedown = function (event) {
      self.mouse_position = event
    };
    this.selected_branch = this.$route.params.branch_id
    this.get_lists();
    this.get_branches();

    bus.$on(this.confirm_delete_name , (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },
    'selected_branch': function () {
      this.get_lists();
    }
  },
  methods: {
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(
                  self.branch_items, content_data.data,
                  'branchId','branchTitle');


          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    tree_view_direction() {
      if (this.$i18n.locale == 'fa') {
        return 'tree-rtl text-right'
      }
      if (this.$i18n.locale == 'en') {
        return 'tree-ltr text-left'
      }
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    click_node(node) {
      // this.$refs.dropdown_menu.$el.getElementsByTagName('button')[0].click()
      console.log(JSON.stringify(event))
      var self = this;
      this.selected_node = node
      this.get_mate_accounts()
      setTimeout(function () {
        // self.$refs.menu.open(self.mouse_position,null)

        // var obj = self.$refs.dropdown_menu.$el.getElementsByTagName('button')[0]
      }, 300);
    },
    right_click_node(node) {
      // this.$refs.dropdown_menu.$el.getElementsByTagName('button')[0].click()
      console.log('right',node)
      var self = this;
      this.selected_node = node
      this.get_mate_accounts()
      setTimeout(function () {
        self.$refs.menu.open(self.mouse_position, null)

        // var obj = self.$refs.dropdown_menu.$el.getElementsByTagName('button')[0]
      }, 300);
    },
    get_mate_accounts() {
      this.data_accounting_tree = [];

      this.data_with_children.forEach((val) => {
        if (val.parentId == this.selected_node.id && val.recType == 1) {

          var obj = {
            "text": val.title,

            parentId: val.parentId,
            id: val.id,
            recType: val.recType,
            image_url: '/img/avatars/custom.png',

            // "selected":true,
            // children: self.get_childrens(val.id, response.data.data),
            // mate: self.get_mates(val.id, response.data.data)
          }
          this.data_accounting_tree.push(obj);
        }

      });
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '') {
        return true;
      }
      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    onClick(text) {
      if (text == 'addPosition') {
        this.addGroupModal = true;
        this.position_or_unit = 1;
      }
      if (text == 'addUnit') {
        this.addGroupModal = true;
        this.position_or_unit = 0;

      }
      if (text == 'edit') {
        this.status_form = this.selected_node.id
        this.name = this.selected_node.name
        this.position_or_unit = this.selected_node.recType
        this.addGroupModal = true;

      }
      if (text == 'delete') {
        this.delete_item_dialog(this.selected_node);
      }
    },

    edit_item(item) {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].catTitle;
      this.color = this.items[item.row_id].color;
      this.code = item.code;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].recId;
      setTimeout(() =>
              this.$refs.add_container.scrollIntoView()
          , 500);
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;

      const formData = new FormData();

      formData.append('Id', this.selected_branch);


      axios.post('GetJobTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.data_accounting = {
            name: localStorage.getItem('app_name'),
            image_url: '/img/avatars/custom.png',
            class: ["rootNode"],
            children: []
          }


          self.data_with_children = response.data.data;
          response.data.data.forEach((val) => {
            if (val.parentId == 0) {

              var obj = {
                "name": val.title,

                parentId: val.parentId,
                id: val.id,
                recType: val.recType,
                image_url: '/img/avatars/custom.png',

                // "selected":true,
                children: self.get_childrens(val.id, response.data.data),
                // mate: self.get_mates(val.id, response.data.data)
              }

              self.data_accounting.children.push(obj);
            }

          });
          if (self.selected_node == 0) {
            self.selected_node = self.data_accounting.children[0];
            // this.selected_node = node
          }
          self.get_mate_accounts()

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 0) {
          var obj = {
            name: val2.title,
            id: val2.id,
            children: this.get_childrens(val2.id, list),
            // mate: this.get_mates(val2.id, list),
            recType: val2.recType,

            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',

          }
          array.push(obj);

          // val2.inserted = true;

        }
        // if (parent_id == val2.parentId &&val2.recType == 1) {
        //   var obj2 = {
        //     name: val2.title,
        //     id: val2.id,
        //     children: this.get_childrens(val2.id, list),
        //     // mate: this.get_mates(val2.id, list),
        //     recType: val2.recType,
        //
        //     class:["my_mate"],
        //     parentId: val2.parentId,
        //     image_url: '/img/avatars/custom2.png',
        //
        //   }
        //   array.push(obj2);

        // val2.inserted = true;

        // }
      });
      if (array.length) {
        return array;

      } else {
        return null;

      }

    },
    get_mates(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId && val2.recType == 1) {
          var obj = {
            name: val2.title,
            id: val2.id,
            children: this.get_childrens(val2.id, list),
            mate: this.get_mates(val2.id, list),
            parentId: val2.parentId,
            image_url: '/img/avatars/custom.png',

          }
          array.push(obj);
          // val2.inserted = true;

        }
      });

      if (array.length) {
        return array;

      } else {
        return null;

      }
    },
    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }
      this.addGroupModal = false;


      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddJobTitle";
        formData.append('ParentId', this.selected_node.id);

      } else {
        url = "EditJobTitle";
        formData.append('id', this.status_form)
        formData.append('ParentId', this.selected_node.parentId);

      }

      formData.append('recType', this.position_or_unit);
      formData.append('title', this.name);
      formData.append('branchId', this.selected_branch);

      axios.post(url, formData, {}).then((res) => {



        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.color = '#ffffff';
        self.code = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();


      })

          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      console.log(this)
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [this.selected_node.name]), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteJobTitle";


      formData.append('id', this.status_form);
      formData.append('branchId', this.selected_branch);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {
            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
<style>
.table {
  color: black;
}

.extend_handle {
  color: black;
  width: 30px !important;
  height: 30px !important;

}

.extend_handle:before {
  border-color: #000000 #000000 transparent transparent !important;
}

.childLevel:before, .extend:after {
  border-left: 2px solid #000000 !important;
}

.childLevel:first-child:after {
  border-color: #000000 transparent transparent #000000 !important;
}

.childLevel:before, .extend:after {
  border-left: 2px solid #000000 !important;
}

.childLevel:last-child:after {
  border-color: #000000 #000000 transparent transparent !important;
}

.childLevel:after {

  border-top: 2px solid #000000 !important;
}

.node .person .avat {
  border: 1px solid #000000 !important;
}

.node {
  width: 6em !important;
}
</style>